export interface ItineraryDay {
	day: number;
	title: string;
	description: string;
	activities: string[];
}

export interface Expedition {
	id: string;
	title: string;
	subtitle: string;
	location: string;
	country: string;
	durationDays: number;
	durationText?: string;
	image: string;
	rating: number;
	reviewsCount: number;
	difficulty: string;
	featured: boolean;
	badge?: string;
	description: string;
	highlights: string[];
	accommodations: string;
	inclusions: string[];
	detailedItinerary: ItineraryDay[];
	requiredPreparations?: string[];
}

export interface BookingDetails {
	expeditionId: string;
	travelDate: string;
	travelerCount: number;
	aviationTransfer: 'standard' | 'private-cessna' | 'chartered-helicopter';
	dietaryPreference: 'none' | 'bush-vegan' | 'gluten-free' | 'gourmet-halal' | 'classic-savannah';
	specialRequests: string;
}

export type Language = 'en' | 'it' | 'fr' | 'de';

export interface LanguageOption {
	code: Language;
	name: string;
	flag: string;
}

export const LANGUAGES: LanguageOption[] = [
	{ code: 'en', name: 'English', flag: '🇬🇧' },
	{ code: 'it', name: 'Italiano', flag: '🇮🇹' },
	{ code: 'fr', name: 'Français', flag: '🇫🇷' },
	{ code: 'de', name: 'Deutsch', flag: '🇩🇪' },
];
